import { Button } from "primereact/button";

import { actionTooltipProps, Icon } from "@/ds";
import { hubTableCartao } from "./hub-table-cartao.constants";

const DETAIL_TOOLTIP = actionTooltipProps("Detalhar", { event: "hover" });

export interface HubTableDetailButtonProps {
  /** Nome acessível da lupa (ex.: "Detalhar obra OB-1"). */
  readonly label: string;
  readonly testId: string;
  /** Sem ele o botão não faz nada: a linha clicável da tabela abre o detalhe. */
  readonly onDetail?: () => void;
  /** A lupa abre um modal sobre a listagem. */
  readonly opensDialog?: boolean;
}

/** Lupa de Detalhamento da última coluna das listagens em cartão. */
export function HubTableDetailButton({
  label,
  testId,
  onDetail,
  opensDialog,
}: HubTableDetailButtonProps) {
  return (
    <Button
      type="button"
      className={hubTableCartao.actionButtonClassName}
      icon={<Icon name="search" size={14} />}
      aria-label={label}
      aria-haspopup={opensDialog ? "dialog" : undefined}
      tooltip={DETAIL_TOOLTIP.content as string}
      tooltipOptions={{ position: DETAIL_TOOLTIP.position, event: "hover" }}
      onClick={onDetail}
      data-testid={testId}
      severity="secondary"
      text
    />
  );
}
